export const DISABLED_PREFILLED_FORM_FIELDS = ['email']
export const DISABLED_MANDATORY_FIELDS = ['name', 'email']
export const REGISTRATION_FORM_ID = 'RegistrationForm'
export const NO_MEMBERSHIP_PLAN_ORDER_ID = 'no-membership'
